<template>
    <nav class="gz-menu gz-menu__topMenu">
        <slot></slot>
    </nav>
</template>

<script>
export default {
    name: 'BaseTopMenu'
}
</script>